import {OrdnerEnum} from '../model/ordner.enum';
import {NachrichtSummary} from '../model/nachricht/nachricht';
import {NachrichtAction} from "../../shared/components/nachricht-action-buttons/nachricht-action.enum";


export class NachrichtActionButtonProvider {

  getButtons(ordner: OrdnerEnum, message: NachrichtSummary, onlineKommunikation:boolean): NachrichtAction[] {
    const nachrichtActions: NachrichtAction[] = [];
    if (ordner === OrdnerEnum.ERHALTEN && message?.gelesen && message?.antwortErlaubt && onlineKommunikation) {
      nachrichtActions.push(NachrichtAction.REPLY);
    }
    if (ordner === OrdnerEnum.ENTWURF) {
      nachrichtActions.push(NachrichtAction.EDIT);
    }
    if ((ordner === OrdnerEnum.ERHALTEN && message?.gelesen) || ordner === OrdnerEnum.GESENDET || ordner === OrdnerEnum.ENTWURF) {
      nachrichtActions.push(NachrichtAction.DOWNLOAD);
    }
    if (ordner === OrdnerEnum.GELOESCHT) {
      nachrichtActions.push(NachrichtAction.RESTORE);
    }
    if ((ordner === OrdnerEnum.ERHALTEN && message?.gelesen) || ordner === OrdnerEnum.GESENDET || ordner === OrdnerEnum.ENTWURF) {
      nachrichtActions.push(NachrichtAction.DELETE);
    }
    if ((ordner === OrdnerEnum.GELOESCHT && message?.gelesen)) {
      nachrichtActions.push(NachrichtAction.DELETE_IRREVOCABLE);
    }
    return nachrichtActions;
  }

}
